import { memo } from 'react';
import { UserInput } from 'src/actuators/user-input/types';
import { LocalesEnum, RegionsEnum } from 'src/generated/operations';
import { prepareUserInputFormValues } from 'src/actuators/common/prepareUserInputFormValues.ts';
import { useBelimoTranslate } from 'src/common/hooks/useBelimoTranslate.ts';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { MapFieldToLabel } from 'src/actuators/common/UserInputFields.ts';

type Props = {
    region: RegionsEnum;
    state: UserInput;
    currentLocale: LocalesEnum;
    isLinear: boolean;
}

export const ActuatorBreadcrumbValue = memo(({ region, state, isLinear, currentLocale }: Props) => {
    const translate = useBelimoTranslate();
    return prepareUserInputFormValues({
        currentLocale,
        isLinear,
        translate,
        currentRegion: region,
        userInput: state,
    }).filter(([_, value]) => Boolean(value)).map(([label, value, unit], i) => (
        <span
            key={`breadcrumb-value-${label}`}
        >{i > 0 ? ', ' : ''} {[MapFieldToLabel.air, MapFieldToLabel.crankArmLength].includes(label)
                ? <I18n messageId={label}/> : ''} {value}{unit.length > 0 ? [' ', <I18n messageId={unit}/>] : ''}
        </span>
    ));
});
